import { OAUTH_PROVIDERS } from '~/common/auth/providers'

/** Sign-in methods that can be recorded: the password and emailed-code paths, plus every OAuth
 * provider */
export type AuthMethod = 'email' | 'code' | (typeof OAUTH_PROVIDERS)[number]

const STORAGE_KEY = 'doss.arp.last-auth-method'

const AUTH_METHODS: ReadonlySet<string> = new Set<AuthMethod>(['email', 'code', ...OAUTH_PROVIDERS])

const isAuthMethod = (value: string | null): value is AuthMethod =>
  value !== null && AUTH_METHODS.has(value)

/** The method that last signed in successfully on this browser, or null if unknown */
export const getLastAuthMethod = (): AuthMethod | null => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return isAuthMethod(stored) ? stored : null
  } catch {
    return null
  }
}

export const setLastAuthMethod = (method: AuthMethod): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, method)
  } catch {
    // Storage unavailable (private mode, blocked site data). The badge simply won't show.
  }
}
